// src/pages/Private/Student/AssignmentView/ViewFeedback.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../../../utils/axios';
import './ViewFeedback.css';

function ViewFeedback() {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const [submission, setSubmission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFeedback();
  }, [assignmentId]);

  const loadFeedback = async () => {
    try {
      const response = await axios.get(`/assignments/${assignmentId}/my-submission`);
      setSubmission(response.data);
    } catch (error) {
      console.error('Geri bildirim yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="view-feedback">
      <h1>Ödev Geri Bildirimi</h1>

      <div className="feedback-card">
        <div className="feedback-header">
          <h2>{submission?.assignment?.title}</h2>
          <div className={`grade-badge ${submission?.grade >= 70 ? 'passed' : 'failed'}`}>
            {submission?.grade} / {submission?.assignment?.totalPoints}
          </div>
        </div>

        <div className="feedback-meta">
          <div className="meta-item">
            <span className="meta-label">Teslim Tarihi:</span>
            <span className="meta-value">
              {new Date(submission?.submittedAt).toLocaleDateString('tr-TR')}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Değerlendirme Tarihi:</span>
            <span className="meta-value">
              {submission?.gradedAt 
                ? new Date(submission.gradedAt).toLocaleDateString('tr-TR')
                : 'Değerlendirilmedi'}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Durum:</span>
            <span className={`status-badge ${submission?.status}`}>
              {submission?.status === 'graded' ? 'Değerlendirildi' : 
               submission?.status === 'late' ? 'Geç Teslim' : 'Teslim Edildi'}
            </span>
          </div>
        </div>

        {submission?.files?.length > 0 && (
          <div className="submitted-files">
            <h3>Teslim Edilen Dosyalar</h3>
            <ul>
              {submission.files.map((file, index) => (
                <li key={index}>
                  <a href={file.fileUrl} target="_blank" rel="noopener noreferrer">
                    📎 {file.fileName}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        {submission?.notes && (
          <div className="student-notes">
            <h3>Öğrenci Notu</h3>
            <p>{submission.notes}</p>
          </div>
        )}

        {submission?.feedback && (
          <div className="teacher-feedback">
            <h3>Öğretmen Geri Bildirimi</h3>
            <p>{submission.feedback}</p>
          </div>
        )}

        <div className="feedback-actions">
          <button className="btn-primary" onClick={() => navigate('/student/courses')}>
            Kurslara Dön
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewFeedback;